import { render, staticRenderFns } from "./visits_report.vue?vue&type=template&id=37a3cc48&scoped=true&"
import script from "./visits_report.vue?vue&type=script&lang=js&"
export * from "./visits_report.vue?vue&type=script&lang=js&"
import style0 from "./visits_report.vue?vue&type=style&index=0&id=37a3cc48&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3cc48",
  null
  
)

export default component.exports